const DEV = process.env.NODE_ENV === 'development'

import Flickity from 'flickity'
import 'flickity/dist/flickity.min.css'
import { getEvolokActions } from '../util/EvolokSingleton'
import { getElement } from 'openseadragon'
require('flickity-fade')
require('flickity-imagesloaded')

function setCookie(cname, cvalue, exdays) {
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  let expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

function getCookie(cname) {
  let name = cname + '='
  let ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export default {
  init() {
    console.log('init pageTemplatePageEvolokDashboard')
    // Show dashboard when content is ready

    // document.addEventListener('evolokRender', (e) => {
    //   console.log('Evolok has been rendered')
    //   loader.classList.add('hidden')
    // })

    // Logic for tab navigation
    const menuLinks = document.querySelectorAll(
      '#userMenu a[href^="#"], #userMenuMobile a[href^="#"], a.dashboard-btn'
    )
    const contentDivs = document.querySelectorAll('#dashboardContent > div')

    if (contentDivs.length === 0) {
      return
    }

    let isInvitation

    function waitForElement(
      selector,
      callback,
      timeout = 5000,
      callbackIfAbsent
    ) {
      let done = false
      let observer
      let timer

      const finish = (el) => {
        if (done) return
        done = true
        if (observer) observer.disconnect()
        if (timer) clearTimeout(timer)
        callback(el)
      }

      const initial = document.querySelector(selector)
      if (initial) {
        finish(initial)
        return
      }

      observer = new MutationObserver(() => {
        const el = document.querySelector(selector)
        if (el) {
          finish(el)
        }
      })

      observer.observe(document.body, { childList: true, subtree: true })

      timer = setTimeout(() => {
        if (!done) {
          done = true
          console.warn(`Elemento ${selector} non trovato entro ${timeout}ms`)
          observer.disconnect()
          if (callbackIfAbsent && typeof callbackIfAbsent === 'function') {
            callbackIfAbsent()
          }
        }
      }, timeout)
    }

    function showContent(hash, isInvitation) {
      if (isInvitation) {
        waitForElement('ev-grant', (block) => {
          const container = document.getElementById('grant-invitiation-block')
          if (container) {
            container.classList.remove('hidden')
            block.style.display = 'block'
            container.appendChild(block)
            document.getElementById('subscribe_banner').style.display = 'none'
          }
        })
      } else {
        document.getElementById('grant-invitiation-block').style.display =
          'none'
      }

      const userMenu = document.getElementById('userMenu')
      const backBtn = document.getElementById('backBtn')
      let dashboardOpen = false

      let targetDivId = hash || `#${contentDivs[0].id}`
      let targetDiv = document.querySelector(targetDivId)

      if (targetDiv) {
        contentDivs.forEach((div) => (div.style.display = 'none'))
        targetDiv.style.display = 'block'

        const allLinks = document.querySelectorAll(
          '#userMenu a, #userMenuMobile a'
        )
        allLinks.forEach((l) => l.classList.remove('active'))

        const activeLinks = document.querySelectorAll(
          `a[href="${targetDivId}"]`
        )
        activeLinks.forEach((l) => l.classList.add('active'))
      }

      let content
      const targetId = targetDiv.id
      if (targetId === 'account') {
        content = document.querySelector(
          'ev-edit-profile[service-name="account"]'
        )
        dashboardOpen = true
      }
      if (targetId === 'changePassword') {
        content = document.querySelector('ev-change-password')
        dashboardOpen = true
      }
      if (targetId === 'subscription') {
        content = document.querySelector('ev-purchases-list')
        dashboardOpen = true
      }
      if (targetId === 'newsletter') {
        content = document.querySelector(
          'ev-edit-profile[service-name="newsletters"]'
        )
        targetDiv = document.querySelector('#evolokNl')
      }

      if (content) {
        content.style.display = 'block'
        targetDiv.appendChild(content)
      }

      if (userMenu && backBtn) {
        userMenu.style.display = dashboardOpen ? 'none' : 'block'
        backBtn.style.display = dashboardOpen ? 'block' : 'none'
      }
    }

    let lastSearch = window.location.search

    const originalPushState = history.pushState
    history.pushState = function (...args) {
      originalPushState.apply(this, args)

      const newSearch = window.location.search
      if (newSearch !== lastSearch) {
        const hadInvitation = new URLSearchParams(lastSearch).has(
          'invitationKey'
        )
        const hasInvitation = new URLSearchParams(newSearch).has(
          'invitationKey'
        )

        if (hadInvitation && !hasInvitation) {
          showContent(window.location.hash, false)
        }

        lastSearch = newSearch
      }
    }

    const originalReplaceState = history.replaceState
    history.replaceState = function (...args) {
      originalReplaceState.apply(this, args)

      const newSearch = window.location.search
      if (newSearch !== lastSearch) {
        const hadInvitation = new URLSearchParams(lastSearch).has(
          'invitationKey'
        )
        const hasInvitation = new URLSearchParams(newSearch).has(
          'invitationKey'
        )

        if (hadInvitation && !hasInvitation) {
          console.log('❌ invitationKey rimosso!')
          showContent(window.location.hash, false)
        }

        lastSearch = newSearch
      }
    }
    menuLinks.forEach((link) => {
      link.addEventListener('click', function (event) {
        event.preventDefault()
        const targetId = this.getAttribute('href')
        const hasInvitation = new URLSearchParams(window.location.search).has(
          'invitationKey'
        )
        showContent(targetId, hasInvitation)

        if (history.pushState) {
          history.pushState(null, null, targetId)
        } else {
          window.location.hash = targetId
        }
      })
    })

    window.addEventListener('popstate', function (event) {
      showContent(window.location.hash, isInvitation)
    })

    console.log('Attaching renderAccountOverview')
    function renderAccountOverview(userInfo) {
      console.log('userInfo', userInfo)
      const { accountInfo, subscriptionInfo, segments } = userInfo
      const name = document.getElementById('name')
      const email = document.getElementById('email')

      if (accountInfo?.first_name)
        name.innerText = `${accountInfo?.first_name} ${accountInfo?.last_name}`
      email.innerText = accountInfo?.email_address

      const registeredDivsToShow = document.querySelectorAll('.to-show-reg')
      const subscribedDivsToShow = document.querySelectorAll('.to-show-sub')
      const subscribedDivsClass = document.querySelectorAll('.only-sub')

      if (
        segments?.includes('Subscriber') ||
        segments?.includes('Domain-based Access')
      ) {
        document.getElementById('subscribe_banner').style.display = 'none'
        subscribedDivsToShow.forEach((item) => item.classList.remove('hidden'))
      } else {
        registeredDivsToShow.forEach((item) => item.classList.remove('hidden'))
        subscribedDivsClass.forEach((item) => item.classList.add('off'))
      }
    }
    // Render counter section
    function initCounter(item) {
      if (!item) return

      item.counterTarget = +item.innerText
      item.counterCount = 0
      item.counterSpeed = 100
      item.counterStep = 1
      item.innerText = item.counterCount

      item.updateCounter = function () {
        item.counterCount += item.counterStep
        if (item.counterCount > item.counterTarget)
          item.counterCount = item.counterTarget
        item.innerText = Math.ceil(item.counterCount)

        if (item.counterCount < item.counterTarget) {
          setTimeout(item.updateCounter, item.counterSpeed)
        }
      }

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            item.updateCounter()
            obs.unobserve(item)
          }
        })
      })

      observer.observe(item)
    }

    // Getting dashboard info
    const loader = document.getElementById('loader')

    let cachedUserInfo

    function onEvolokUserReady(callback) {
      // If the event already fired → call immediately
      if (window.evolokUserReadyData) {
        callback({ detail: window.evolokUserReadyData })
      }
      // Also wait for future events
      document.addEventListener('evolokUserReady', callback)
    }
    onEvolokUserReady(async (e) => {
      console.log('evolokUserReady received in dashboard')
      const evActions = getEvolokActions()
      evActions.savedArticlesSection = document.getElementById('savedArticles')

      try {
        console.log('Try Loading account info and articles...')
        if (!cachedUserInfo) {
          const userInfo = await evActions.getUserInfo()

          if (!userInfo) return

          cachedUserInfo = userInfo
        }

        renderAccountOverview(cachedUserInfo)
        renderAccountNlOverview(cachedUserInfo)

        if (
          e.detail.userType === 'subscribed' ||
          cachedUserInfo?.segments?.includes('Domain-based Access') ||
          cachedUserInfo?.segments?.includes('IP-based Access')
        ) {
          // Saved articles load on request
          const saveArticleBtn = document.querySelector('#saveArticleBtn')
          saveArticleBtn?.addEventListener('click', () =>
            loadSavedArticles(evActions)
          )

          const currentHash = document.location.hash
          const isSavedArticlesTab =
            currentHash && currentHash === '#savedArticles'
          if (isSavedArticlesTab) {
            loadSavedArticles(evActions)
          }
        }
      } catch (err) {
        console.error('Error loading account info or articles:', err)
        document.getElementById('dashboardContent').style.opacity = 1
        loader.classList.add('hidden')
      } finally {
        if (cachedUserInfo) {
          document.getElementById('dashboardContent').style.opacity = 1
          loader.classList.add('hidden')
        }
      }
    })

    // Logic for the counter
    var elements = document.querySelectorAll('.js-counter-number')

    elements.forEach(function (item) {
      console.log('Initializing counter for item:', item)
      item.counterAlreadyFired = false
      item.counterSpeed = 100
      item.counterTarget = +item.innerText
      item.counterStep = 1

      const cookieName = item.getAttribute('data-name')
      if (getCookie(cookieName)) {
        if (getCookie(cookieName) == item.counterTarget) {
          item.counterCount = 0
        } else {
          item.counterCount = getCookie(cookieName)
          setCookie(cookieName, item.counterTarget, 365)
        }
      } else {
        item.counterCount = 0
        setCookie(cookieName, item.counterTarget, 365)
      }
      item.innerText = item.counterCount

      item.updateCounter = function () {
        item.counterCount = item.counterCount + item.counterStep
        item.innerText = Math.ceil(item.counterCount)

        if (item.counterCount < item.counterTarget) {
          setTimeout(item.updateCounter, item.counterSpeed)
        } else {
          item.innerText = item.counterTarget
        }
      }
    })

    var isElementVisible = function isElementVisible(el) {
      var rect = el.getBoundingClientRect()
      return (
        rect.top >= 0 &&
        rect.bottom + 20 <=
          (window.innerHeight || document.documentElement.clientHeight)
      )
    }

    var handleScroll = function handleScroll() {
      elements.forEach(function (item, id) {
        if (true === item.counterAlreadyFired) return
        if (!isElementVisible(item)) return
        item.updateCounter()
        item.counterAlreadyFired = true
      })
    }

    window.addEventListener('scroll', handleScroll)

    /* NEWSLETTER */

    //Manage subscription privileges
    function renderAccountNlOverview(userInfo) {
      const { subscriptionInfo, segments } = userInfo

      if (
        subscriptionInfo.active_subscription ||
        subscriptionInfo.active_beneficiary
      )
        return
      const nlItems = document.querySelectorAll('.nl-item.subscribers_only')
      nlItems.forEach((item) => item.classList.add('off'))
    }
    // Check NL subscription status
    function checkNlSubscriptionStatus() {
      const checkboxes = document.querySelectorAll(
        'ev-edit-profile[service-name="newsletters"] input[type="checkbox"]'
      )

      checkboxes.forEach((checkbox) => {
        const { id } = checkbox
        if (!id) return

        const notSubscriptedBtn = document.querySelector(`#btns-${id} .not-sub`)
        const subscriptedBtn = document.querySelector(`#btns-${id} .sub`)

        if (!notSubscriptedBtn || !subscriptedBtn) return

        // Toggle display basato sullo stato checked
        const displayState = checkbox.checked
          ? ['block', 'none']
          : ['none', 'block']
        notSubscriptedBtn.style.display = displayState[0]
        subscriptedBtn.style.display = displayState[1]
      })
    }

    // Manage subscription status
    const nlSubBtns = document.querySelectorAll('.nl-subscribe-btn')
    if (nlSubBtns) {
      nlSubBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault()
          let id = btn.getAttribute('data-id')
          if (id) {
            let checkbox = document.getElementById(id)
            if (checkbox) {
              checkbox.click()
              const updateBtn = document.querySelector(
                '#newsletter #buttonPanel button[type="submit"]'
              )
              updateBtn.click()
              setTimeout(() => checkNlSubscriptionStatus(), 500)
            }
          }
        })
      })
    }

    /* FINE NEWSLETTER */

    // Check subscription status and add class to ACTIVE items
    function checkSubscriptionStatus() {
      console.log('Checking subscription status...')
      if (!lgc_global.labels.status) return
      console.log('lgc_global.labels.status:', lgc_global.labels.status)
      const tds = document.querySelectorAll(
        '.purchase-item .vertical-table-header'
      )
      tds.forEach((span) => {
        if (
          span.textContent.trim().toLowerCase() ===
          lgc_global.labels.status.toLowerCase()
        ) {
          const td = span.closest('td')
          const tr = td?.parentElement

          if (tr) {
            const secondTd = tr.children[1]
            if (secondTd && secondTd !== td) {
              tr.insertBefore(td, secondTd)
            }
          }

          const nextSpan = span.nextElementSibling
          if (nextSpan && nextSpan.tagName === 'SPAN') {
            nextSpan.classList.add('status-label')
            const text = nextSpan.textContent.trim().toLowerCase()
            nextSpan.textContent = text.charAt(0).toUpperCase() + text.slice(1)
            let classToAdd = ''

            if (
              text === lgc_global.labels.active.toLowerCase() ||
              text === lgc_global.labels.completed.toLowerCase()
            ) {
              classToAdd = 'active'
            } else if (text === lgc_global.labels.pending.toLowerCase()) {
              classToAdd = 'pending'
            }

            if (classToAdd) {
              nextSpan.classList.add(classToAdd)
            }
          }
        }
      })
    }

    // Overwrite "Frequence" for translation
    function editPurchasesListLabels() {
      const tds = document.querySelectorAll(
        '.purchase-item .vertical-table-content'
      )
      tds.forEach((span) => {
        switch (span.textContent.trim().toLowerCase()) {
          case 'semaine':
            span.textContent = lgc_global.labels.weekly
            break
          case 'mois':
            span.textContent = lgc_global.labels.monthly
            break
          case 'an':
            span.textContent = lgc_global.labels.yearly
            break
        }
      })
    }

    document.addEventListener('evolokRender', () => {
      console.log('Evolok has been rendered')
      const currentUrlParams = new URLSearchParams(window.location.search)
      const isInvitation = currentUrlParams.has('invitationKey')

      // showContent
      waitForElement('ev-edit-profile[service-name="account"]', () => {
        console.log('Showing content based on URL hash...')
        if (typeof showContent === 'function') {
          showContent(window.location.hash, isInvitation)
        }
      })

      // checkNlSubscriptionStatus
      waitForElement(
        'ev-edit-profile[service-name="newsletters"] input[type="checkbox"]',
        () => {
          if (typeof checkNlSubscriptionStatus === 'function') {
            checkNlSubscriptionStatus()
          }
        }
      )
    })

    document.addEventListener('purchasesLoaded', () => {
      console.log('purchasesLoaded event received')
      setTimeout(function () {
        editPurchasesListLabels()
        checkSubscriptionStatus()
      }, 500)
    })

    let cachedSavedArticles
    let savedArticlesLoaded = false

    async function loadSavedArticles(actions) {
      if (savedArticlesLoaded) return

      savedArticlesLoaded = true

      try {
        loader.classList.remove('hidden')
        if (!cachedSavedArticles) {
          cachedSavedArticles = await actions.getSavedArticles()
        }

        if (cachedSavedArticles) {
          actions.renderArticles(cachedSavedArticles, 'saved')
        } else {
          savedArticlesLoaded = false
        }
      } catch (err) {
        console.error('Error loading saved articles:', err)
        savedArticlesLoaded = false
      } finally {
        loader.classList.add('hidden')
      }
    }
  },
  finalize() {
    console.log('finalize DashBoardPage')
    // JavaScript to be fired on all pages, after page specific JS is fired
    //console.log('finalize common');
  },
}
